<template>
  <div
    class="full-page"
    :class="{
      'nav-open': $sidebar.showSidebar,
      'full-page--login-shell': isLoginShellRoute,
      'full-page--hub-sunset': isHubSunsetRoute,
    }"
  >
    <div
      class="wrapper wrapper-full-page"
      :class="{ 'wrapper-full-page--hub-sunset': isHubSunsetRoute }"
      @click="onWrapperClick"
    >
      <notifications v-if="!isHubSunsetRoute"/>
      <div
        class="page-header header-filter"
        :class="[
          setPageClass,
          {
            'header-filter--login-shell': isLoginShellRoute,
            'clear-filter': isLoginShellRoute,
          },
        ]"
        filter-color="black"
        :style="isLoginShellRoute ? {} : setBgImage"
      >
        <div :class="isLoginShellRoute ? 'login-shell-container' : 'container md-offset'">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  inject: {
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear()
    };
  },
  computed: {
    isHubSunsetRoute() {
      return this.$route && this.$route.name === "HubSunset";
    },
    isLoginShellRoute() {
      const name = this.$route && this.$route.name;
      return name === "Login" || name === "AgencyLogin" || this.isHubSunsetRoute;
    },
    setBgImage() {
      let images = {
        Login: process.env.VUE_APP_BASE_URL + "/img/login.jpg",
        Register: process.env.VUE_APP_BASE_URL + "/img/register.jpg",
        HubSunset: "",
        ChatDomainLaunch: process.env.VUE_APP_BASE_URL + "/img/login.jpg",
        LegacySocialRedirect: process.env.VUE_APP_BASE_URL + "/img/login.jpg",
      };
      return {
        backgroundImage: `url(${images[this.$route.name]})`
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    }
  },
  methods: {
    onWrapperClick() {
      if (this.isLoginShellRoute) {
        return;
      }
      this.toggleSidebarPage();
    },
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
.full-page {
  background: #6994b8 url("/img/login2.jpg");
  background-size: cover;
}

.full-page--login-shell {
  background: #f8fafc !important;
  background-image: none !important;
}

.full-page--hub-sunset {
  background: transparent !important;
  background-image: none !important;
}

.header-filter--login-shell {
  background: transparent !important;
  background-image: none !important;
  min-height: 100vh;
  min-height: 100svh;

  &::before,
  &::after {
    display: none !important;
    pointer-events: none !important;
  }
}

.login-shell-container {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  pointer-events: auto;
}

.wrapper-full-page--hub-sunset {
  min-height: 100vh;
  min-height: 100svh;
}

.wrapper-full-page--hub-sunset .login-shell-container {
  min-height: 100vh;
  min-height: 100svh;
  padding: 0;
}
</style>
